import ApiService from '@/common/api.service';
import Toast from '@/common/toast';

const resource = 'booktype';

const BooktypeService = {
    async get(slug) {
        return ApiService.get(resource, slug);
    },
    async getServiceInterval() {
        return ApiService.get(resource + '/serviceinterval/all');
    },
    async query(params) {
        return ApiService.query(resource, params);
    },
    async queryActive(params) {
        return ApiService.query(resource + '/active', params);
    },
    async create(params) {
        let promise = null;
        try {
            promise = await ApiService.post(resource, params);
            Toast.showCreateOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
    async update(slug, params) {
        let promise = null;
        try {
            promise = await ApiService.update(resource, slug, params);
            Toast.showSaveOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
    async delete(slug) {
        let promise = null;
        try {
            promise = await ApiService.delete(resource, slug);
            Toast.showDeleteOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
};

export default BooktypeService;
